const H = (name, town, region, phone = null, tel = null) => ({ name, town, region, phone, tel });

export const HOSPITALS = [
  H("Centro Médico de Puerto Rico", "Río Piedras, San Juan", "metro", "787-777-3535", "7877773535"),
  H("Hospital Auxilio Mutuo", "San Juan", "metro", "787-758-2000", "7877582000"),
  H("Ashford Presbyterian Community Hospital", "Condado, San Juan", "metro", "787-721-2160", "7877212160"),
  H("Hospital Pavia Santurce", "San Juan", "metro"),
  H("Hospital San Francisco", "Río Piedras, San Juan", "metro"),
  H("Hospital Universitario de Adultos", "Centro Médico, San Juan", "metro"),
  H("Hospital HIMA San Pablo Bayamón", "Bayamón", "metro"),
  H("Hospital de la UPR Dr. Federico Trilla", "Carolina", "metro"),

  H("Hospital Metropolitano Dr. Susoni", "Arecibo", "norte"),
  H("Hospital Pavía Arecibo", "Arecibo", "norte"),
  H("Doctors' Center Hospital", "Manatí", "norte"),
  H("Hospital San Carlos Borromeo", "Moca", "norte"),

  H("Hospital San Lucas", "Ponce", "sur"),
  H("Hospital Damas", "Ponce", "sur"),
  H("Hospital San Cristóbal", "Ponce", "sur"),
  H("Hospital Episcopal San Lucas", "Guayama", "sur"),
  H("Hospital Metropolitano Dr. Tito Mattei", "Yauco", "sur"),

  H("Hospital HIMA San Pablo Humacao", "Humacao", "este"),
  H("Hospital Ryder Memorial", "Humacao", "este"),
  H("Hospital HIMA San Pablo Fajardo", "Fajardo", "este"),
  H("Hospital San Vicente de Paul", "San Lorenzo", "este"),

  H("Mayagüez Medical Center", "Mayagüez", "oeste"),
  H("Hospital San Antonio", "Mayagüez", "oeste"),
  H("Hospital Buen Samaritano", "Aguadilla", "oeste"),
  H("Hospital de la Concepción", "San Germán", "oeste"),

  H("Hospital HIMA San Pablo Caguas", "Caguas", "centro"),
  H("Hospital Menonita de Cayey", "Cayey", "centro"),
  H("Hospital General Menonita", "Aibonito", "centro"),
  H("Hospital San Cristóbal", "Caguas", "centro"),
];
